<script setup lang="ts">

import { ref } from "vue";

const showImage = ref( false );

</script>

<template>

    <div class="bg-white h-full flex items-center">
        <Image src="/page-3.jpg" class="w-full" />
        <div class="absolute w-[34vw] h-[21vw] left-[29%] mt-[2vw] cursor-pointer"
            @click="() => showImage = true">
        </div>
        <Image v-if="showImage"
            src="/product.jpg"
            class="w-full h-full bg-white object-contain cursor-pointer left-0 absolute top-0"
            @click="() => showImage = false" 
        />
    </div>

</template>